<template>
  <div class="tab-pane" role="tabpanel" aria-labelledby="home-tab">
    <div class="row mb-3 mt-3">
      <div class="col-md-3">
        <b-button-group>
          <b-button variant="outline-danger">
            <input
              type="checkbox"
              v-model="selectAll"
              @change="selectItemAll(selectAll)"
            />
          </b-button>
          <b-button
            variant="outline-danger"
            type="button"
            :disabled="recordIds.length == 0"
            @click="multiDelete"
            v-if="$role == 'super_admin'"
          >
            <i class="fa fa-trash"></i>
            {{ $t("site.bulk_delete") }}
          </b-button>
        </b-button-group>
      </div>
      <div class="col-md-6">
        <b-button
          v-b-modal.modal-center
          variant="outline-info"
          v-if="this.$route.params.id != 1"
        >
          {{ $t("menu.name_sub_menu") }}
        </b-button>
      </div>
      <div class="col-3">
        <h1>{{ menu.title }}</h1>
      </div>
    </div>

    <table class="table is-fullwidth is-bordered">
      <thead>
        <tr>
          <th></th>
          <th>{{ this.$i18n.t("pages.title") }}</th>
          <th>{{ this.$i18n.t("pages.type") }}</th>
          <th>{{ this.$i18n.t("site.action") }}</th>
        </tr>
      </thead>
      <draggable
        element="tbody"
        v-model="data"
        class="cursor-move"
        @change="onDrop($event, 1)"
      >
        <tr class="dragndrop" v-for="item in data">
          <td>
            <template>
              <label class="kt-checkbox kt-checkbox--single kt-checkbox--solid">
                <input
                  type="checkbox"
                  v-model="recordIds"
                  :value="item.id"
                  @change="selectItem(item)"
                />
                <span></span>
              </label>
            </template>
          </td>
          <td>{{ item.title }}</td>
          <td>{{ item.type }}</td>
          <td>
            <template>
              <button
                class="btn btn-icon btn-warning btn-sm"
                @click="editItem(item)"
              >
                <i class="fa fa-edit"></i>
              </button>
              <button
                class="btn btn-icon btn-danger btn-sm"
                @click="deleteItem(item)"
                v-if="$role == 'super_admin'"
              >
                <i class="fa fa-trash"></i>
              </button>
            </template>
          </td>
        </tr>
        <b-spinner v-if="load" type="grow" label="Loading..."  class="loading" />
      </draggable>
    </table>
    <b-modal id="modal-center" centered ok-only ok-title="save" @ok="handleOk">
      <b-form-group
        v-for="feild in menuData"
        label-cols="4"
        label-cols-lg="2"
        :label="$t('menu.' + feild.locale)"
      >
        <b-form-input
          id="input-default"
          :placeholder="$t('menu.' + feild.locale)"
          v-model="feild.title"
        />
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import controller from "@/Controllers/MenuController";
import config from "@/config/config";
import draggable from "vuedraggable";
export default {
  name: "MenuDataTable",
  props: ["items", "editItem"],
  components: {
    draggable,
  },
  data() {
    return {
      bootstrapTable: {
        selected: [],
        selectMode: "multi",
        fields: [
          { key: "checkbox", label: "", sortable: false },
          {
            key: "title",
            label: this.$i18n.t("pages.title"),
            sortable: true,
            sortDirection: "desc",
          },

          {
            key: "type",
            label: this.$i18n.t("menu.type"),
            sortable: true,
            sortDirection: "desc",
          },

          { key: "edit", label: this.$i18n.t("site.action"), sortable: false },
        ],
      },
      data: [],
      selectAll: false,
      
      currentPage: 1,
      select: [],
      page: 1,
      perPage: 5,
      search: "",
      from: 0,
      total: 0,
      totalRows: 0,
      to: 0,
      lastPage: 0,
      load: false,
      apiParams: {},
      params: {},
      recordIds: [],
      menuId: this.$route.params.id,
      menuData: [],
      menu: {},
    };
  },
  async mounted() {
    // console.log("asd",this.$i18n.locale);
    this.dataProvider();
    this.getMenu();
  },
  watch: {
    $route(to, from) {
      console.log(to, from);
      this.menuId = to.params.id;
      let apiParams = { filter: "menu_id|" + to.params.id };
      this.dataProvider(apiParams);
      this.getMenu();
      this.$refs.table.refresh();
    },
  },
  methods: {
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    async dataProvider() {
      this.load = true;
      let apiParams = { filter: "menu_id|" + this.$route.params.id };
      const data = await new controller().GetAll(apiParams);
      this.data = data;
      this.load = false;
      console.log(this.data);
    },
    async getMenu() {
      let apiParams = { id: this.$route.params.id };
      const menu = await new controller().menu(apiParams);
      if (menu.translations.length > 0) {
        this.menuData = menu.translations;
      } else {
        this.menuData = [
          {
            menu_id: this.$route.params.id,
            title: "",
            locale: "ar",
          },
          {
            menu_id: this.$route.params.id,
            title: "",
            locale: "en",
          },
        ];
      }
      this.menu = this.menuData.find((el) => el.locale === this.$i18n.locale);
      console.log(this.menu);
    },
    apiParamsConverter() {
      let apiParams = { per_page: this.perPage };
      if (this.params.currentPage >= 1) {
        apiParams.page = this.params.currentPage;
      }
      if (this.params.sortBy && this.params.sortBy.length > 0) {
        apiParams.sort = `${this.params.sortBy}|${
          this.params.sortDesc ? "desc" : "asc"
        }`;
      }
      if (this.params.filter && this.params.filter.length > 0) {
        // Optional
      }
      if (this.search !== "") {
        apiParams.search = this.search;
      }
      apiParams.filter = "menu_id|" + this.menuId;
      return apiParams;
    },
    changePageSize(perPage) {
      this.page = 1;
      this.perPage = perPage;
      this.dataProvider(this.params);
      this.$refs.table.refresh();
    },
    searchChange() {
      if (this.search.length == 0) {
        this.dataProvider(this.params);
        this.$refs.table.refresh();
      }
      if (this.search.length < 2) return;
      this.page = 1;
      this.dataProvider(this.params);
      this.$refs.table.refresh();
    },
    selectItemAll(select) {
      this.recordIds = [];
      if (select) {
        this.data.forEach((element) => {
          this.recordIds.push(element.id);
        });
      }
    },
   async deleteItem(item) {
     await new controller().Delete(item.id, [] );
      this.dataProvider();
    },
   async multiDelete() {
     await new controller().Delete(0, this.recordIds );
      this.dataProvider();
    },
    afterAdd(evt) {
      console.log(this.data);
    },
    onDrop(evt, list) {
      let newPriority = [];
      this.data.forEach((value, index) => {
        let ob = {
          id: value.id,
          priority: index + 1,
        };
        newPriority.push(ob);
      });
      console.log(newPriority);
      this.updatePriority(newPriority);
    },
    async updatePriority(newPriority) {
      await new controller().updatePriority(newPriority);
    },
    async handleOk() {
      await new controller().updateMenu(this.menuData);
      this.getMenu();
    },
  },
};
</script>

